export default "__VITE_ASSET__7FaM8y12__"